import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from '@core/js/hooks/i18n';
import { hideFooter, showFooter } from '@core/js/components/main/Footer/store/actions';

import style from './LayoutLoader.scss';

export const LayoutLoader = ({ navBarPresent, isPageInPopup }) => { // TotalCasino Changes
    const dispatch = useDispatch();
    const translate = useTranslations();

    useLayoutEffect(() => {
        if (isPageInPopup) {
            return;
        }

        dispatch(hideFooter());

        return () => {
            dispatch(showFooter());
        };
    }, [dispatch, isPageInPopup]);

    return (
        <div className={`${style.layoutLoaderContainer} ${navBarPresent ? style.navBarPresent : ''}`}>
            <p className={style.layoutLoaderText}>{translate('playtech.mobile.system.page-loader.text')}</p>
        </div>
    );
};
